import { Reveal, Overline } from "../components/Reveal";
import { ZAVI_VALUES } from "../data/content";

const SUBTITLES = ["Obsession with the game", "Sharpness in body and mind", "See the pass before it exists", "Match-speed in everything"];

export const ZaviValues = () => (
  <section id="values" className="py-24 sm:py-32 scroll-mt-16" data-testid="values-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <Reveal>
        <Overline>The Name Is The Standard</Overline>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-3">
          Z · A · V · <span className="text-[#D4AF37]">I</span>
        </h2>
      </Reveal>

      <div className="mt-14 space-y-3 sm:space-y-4">
        {ZAVI_VALUES.map((v, i) => (
          <Reveal key={v.letter} delay={i * 0.08}>
            <div className="grid grid-cols-[70px_1fr] sm:grid-cols-[110px_1fr] items-center gap-4 sm:gap-8 border-b border-white/10 py-6 sm:py-8 group hover:bg-[#0A0A0A] transition-colors duration-300"
                 data-testid={`value-${v.letter.toLowerCase()}`}>
              <span className="font-heading text-6xl sm:text-8xl font-black text-[#D4AF37] leading-none">{v.letter}</span>
              <div>
                <p className="font-heading text-xl sm:text-2xl font-black uppercase tracking-tight">{v.word}</p>
                <p className="text-[#D4AF37] text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold mt-1">{SUBTITLES[i]}</p>
                <p className="text-white/60 text-sm sm:text-[15px] mt-3 leading-relaxed max-w-xl">{v.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
